const defaultSocketUrl =
  process.env.REACT_APP_BACKEND_URL || "https://backend.buzzvibe.com";

const fallbackSocketUrl =
  process.env.REACT_APP_SOCKET_FALLBACK_URL ||
  process.env.REACT_APP_LEGACY_SOCKET_URL ||
  defaultSocketUrl;

export const socketEndpoint =
  process.env.REACT_APP_SOCKET_URL || fallbackSocketUrl;
